<style lang="scss">
    .GameFormalNum7 {
        .row {
            .balls, .tools {
                float:none;
                .ball {
                    margin:0 auto; margin-top:0; margin-bottom:0; display:block;
                }
            }
            .odds{
                font-size:13px;
            }
        }
    }
</style>
<template>
    <div class="GameFormalPlay GameFormalNum7">
        <ul v-if="params" class="box">
            <li v-for="(row,unit) in MakeBallDir" class="row l-flex-1">
                <div class="title">
                    <p>{{ row.title }}</p>
                </div>

                {{/* 选球组 */}}
                <div class="balls l-flex" style="width:60%; flex-direction:row; flex-wrap:wrap;">
                    <div v-for="(ball,index) in row.balls" class="o-pb" style="width:72px; text-align:center;">
                        <li class="ball" :class="{'active': params[unit] && params[unit][index]}" @click="Pick(unit,index)">
                            <span>{{ ball.title }}</span>
                        </li>
                        <!--                         <li class="ball"  @click="Pick(unit,index)">
                            <template v-if="params[unit]  && params[unit][index]">
                                <span class="c-color-f">{{ ball.title }}</span>
                                <img src="../../../../../image/game/formal/ball_a.png">
                            </template>
                            <template v-else>
                                <span>{{ ball.title }}</span>
                                <img src="../../../../../image/game/formal/ball.png">
                            </template>
                        </li> -->
                        <p v-if="ball.odds" class="odds">{{ applyOdds(ball.odds) }}</p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import Common from './num7.js'
export default {
    mixins: [Common],
    components: {

    }
}
</script>
